module.exports = __webpack_public_path__ + "static/media/exercise.85d03e4f.svg";